export const dummyMesages = [
  {
    _id: "dummyMessage-1",
    id: "dummyMessage-1",
    uid: "dummyMessage-1",
    creator: "AGENT",
    workitemId: "dummyMessage-1",
    // Original message JSON retained, createdAt added
    message:
      '{"isAiEnabled":true,"components":[{"subType":"default","text":" Hey, I’d like some help with refund.","category":"display","type":"text","richText":"\\n\\t\\t\\t\\t<p class=\\"lexicalEditor-paragraph\\" dir=\\"ltr\\" style=\\"margin: 0; position: relative; margin-bottom: 0;\\"><span style=\\"white-space: pre-wrap;\\"> Hey, I’d like some help with refund.</span></p>\\n\\t\\t\\t\\t"}],"nodeId":"start-state"}',
    messageType: "PRIVATE_MESSAGE",
    messageMediaType: "CUSTOM",
    userType: "USER",
    createdAt: "2023-10-12T11:14:00Z", // Added based on image timestamp
  },
  {
    creator: "AGENT",
    _id: "dummyMessage-2", // Changed ID for uniqueness
    id: "dummyMessage-2", // Changed ID for uniqueness
    uid: "dummyMessage-2", // Changed ID for uniqueness
    workitemId: "dummyMessage-2", // Changed ID for uniqueness
    messageMediaType: "CUSTOM",
    // Original message JSON retained, createdAt added
    message:
      '{"components":[{"subType":"default","text":" Of course, I am on it. Can you confirm your name?","category":"display","type":"text","richText":""},{"category":"input","type":"text","validation":{}}]}',
    messageType: "PRIVATE_MESSAGE",
    userType: "BOT",
    createdAt: "2023-10-12T11:14:00Z", // Added based on image timestamp
  },
  // Added message 3 based on image
  {
    creator: "AGENT",
    _id: "dummyMessage-3",
    id: "dummyMessage-3",
    uid: "dummyMessage-3",
    workitemId: "dummyMessage-3",
    message:
      '{"components":[{"subType":"default","text":"Sure, my name\'s John.","category":"display","type":"text","richText":""}]}', // Simplified JSON structure
    messageType: "PRIVATE_MESSAGE",
    messageMediaType: "CUSTOM",
    userType: "USER",
    createdAt: "2023-10-12T11:16:00Z", // Added based on image timestamp
  },
  // Added message 4 based on image
  {
    creator: "AGENT",
    _id: "dummyMessage-4",
    id: "dummyMessage-4",
    uid: "dummyMessage-4",
    workitemId: "dummyMessage-4",
    message:
      '{"isAiEnabled":true,"components":[{"subType":"default","text":"Great, I have processed your refund. You should receive the amount in 7 business days. Thank you.","category":"display","type":"text","richText":""}]}', // Simplified JSON structure
    messageType: "PRIVATE_MESSAGE",
    messageMediaType: "CUSTOM",
    userType: "BOT",
    createdAt: "2023-10-12T11:24:00Z", // Added based on image timestamp
  },
];
